export const COMPLETED_SECTION_ID = 'completed-goals-section';
export const ARCHIVED_SECTION_ID = 'archived-goals-section';
